import { useSearchParams } from "react-router-dom";

export default function useIId() {
  const [searchParams] = useSearchParams();
  return searchParams.get("iId") ?? searchParams.get("iid");
}
